import { createEffect, createSignal, onCleanup, onMount, Show, type JSX } from "solid-js"
import type { FilePreviewHandler, FilePreviewProps } from "./file-preview-registry"

export function FilePreviewToggle(props: {
  handler: FilePreviewHandler
  previewProps: FilePreviewProps
  renderSource: () => JSX.Element
}) {
  let root!: HTMLDivElement
  const [showSource, setShowSource] = createSignal(false)
  const [viewportHeight, setViewportHeight] = createSignal<number>()
  const hasToggle = () => props.handler.hasSourceToggle === true

  onMount(() => {
    const viewport = root.closest<HTMLElement>(".scroll-view__viewport")
    if (!viewport) return

    const update = () => {
      const available = viewport.getBoundingClientRect().bottom - root.getBoundingClientRect().top
      setViewportHeight(Math.max(400, Math.floor(available)))
    }
    const observer = new ResizeObserver(update)
    observer.observe(viewport)
    observer.observe(root.parentElement ?? root)
    window.addEventListener("resize", update)
    requestAnimationFrame(update)

    onCleanup(() => {
      observer.disconnect()
      window.removeEventListener("resize", update)
    })
  })

  createEffect(() => {
    if (!showSource()) requestAnimationFrame(() => props.previewProps.onRendered?.())
  })

  return (
    <div ref={root} class="file-preview-toggle" style={{ position: "relative", width: "100%" }}>
      <Show when={hasToggle()}>
        <div style={{ position: "absolute", right: "12px", top: "12px", "z-index": "10", display: "flex", gap: "4px", "border-radius": "6px", border: "1px solid var(--color-border-base, #e2e8f0)", background: "var(--color-surface-base, #fff)", padding: "2px" }}>
          <button
            type="button"
            style={{ padding: "4px 8px", "font-size": "12px", "border-radius": "4px", background: showSource() ? "transparent" : "var(--color-surface-raised-base, #f1f5f9)", border: "none", cursor: "pointer" }}
            onClick={() => setShowSource(false)}
          >
            预览
          </button>
          <button
            type="button"
            style={{ padding: "4px 8px", "font-size": "12px", "border-radius": "4px", background: showSource() ? "var(--color-surface-raised-base, #f1f5f9)" : "transparent", border: "none", cursor: "pointer" }}
            onClick={() => setShowSource(true)}
          >
            源码
          </button>
        </div>
      </Show>
      <Show
        when={showSource() && hasToggle()}
        fallback={props.handler.render({ ...props.previewProps, viewportHeight: viewportHeight() })}
      >
        {props.renderSource()}
      </Show>
    </div>
  )
}
